import { render, staticRenderFns } from "./BaseText.vue?vue&type=template&id=08c5d001"
import script from "./BaseText.vue?vue&type=script&lang=js"
export * from "./BaseText.vue?vue&type=script&lang=js"
import style0 from "./BaseText.vue?vue&type=style&index=0&id=08c5d001&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports